/**
 * @deprecated Очень сильно связывает код, сомнительная польза, should be removed
 */
export const defaultTheme = {
    colors: {
        main: '#313140',
        mainBlue: '#0087be',
        hoverBlue: '#00c3ff',
        mainYellow: '#ffca00',
        hoverYellow: '#fed63f'
    },
    fontFamily: 'Open Sans, Arial, sans-serif'
};

export type ThemeType = typeof defaultTheme;
